import { User, UserRole } from "@/types";

export const isAdminUser = (user: User, company: any) =>
  !!user.role?.find((role: UserRole) => role.companyId === company.companyId && role.roleType === "ADMIN");

export const isViewer = (user: User, company: any) =>
  !!user.role?.find((role: UserRole) => role.companyId === company.companyId && role.roleType === "VIEWER");

export const isUser = (user: User, company: any) =>
  !!user.role?.find((role: UserRole) => role.companyId === company.companyId && role.roleType === "USER");
